<template>
    <div v-if="loaded">
      <h1>Communication Preferences</h1>
      <p>Choose which type of emails you would like to receive.</p>

        <div v-for="emailType in emailTypes" :key="emailType.value">
          <el-checkbox v-model="emailType.selected">
            <h3>{{ emailType.label }}</h3>
          </el-checkbox>
          <p class="description">{{ emailType.description }}</p>
        </div>

      <el-button type="primary" @click="saveChanges">Save Changes</el-button>
    </div>
  </template>

<script>
import _ from 'lodash';

export default {
  name: 'CommunicationPreferences',
  props: ['value'],
  data() {
    return {
      loaded: false,
      checkedEmails: [],
      emailTypes: [
        {
          value: 'system',
          selected: true,
          label: 'System Emails',
          description: 'Emails regarding system notifications and updates.'
        },
        {
          value: 'matchReminder',
          selected: true,
          label: 'Match Reminders',
          description: 'Reminders about upcoming matches or events.'
        }
        // You can add more email types as needed
      ]
    };
  },
  created() {
    // fetch the member's preferences
    this.$store.commit('loading', { loading: true, text: 'Loading...' });
    this.$http
      .get(`/assemble/api/v1/admin/members/${this.value._id}/member-preferences`)
      .then((res) => {
        const preferencesRes = res.data.data;

        const foundPreferences = preferencesRes.map((preference) => preference.type);
        // filter out the email types that are in the preferences response, the result will exclude the email types that are in the preferences response
        _.forEach(this.emailTypes, (emailType) => {
          if (foundPreferences.includes(emailType.value)) {
            // update the selected property to false
            this.$set(emailType, 'selected', false);
          }
        });

        console.log('preferencesRes', this.emailTypes);
        this.$store.commit('loading', false);
      })
      .catch((e) => {
        this.$message.error(e.response.data.message);

        this.$store.commit('loading', false);
      });
    this.loaded = true;
  },
  methods: {
    handleEmailCheckbox(emailType) {
      // Handle the checkbox change here
      console.log('handleEmailCheckbox', emailType);
    },
    saveChanges() {
      // Handle saving the changes here, e.g. making an API call
      const uncheckedEmailTypes = this.emailTypes.filter((emailType) => !emailType.selected).map((emailType) => emailType.value);
      console.log('uncheckedEmailTypes', uncheckedEmailTypes);
      this.$store.commit('loading', { loading: true, text: 'Loading...' });
      this.$http
        .post(`/assemble/api/v1/admin/members/${this.value._id}/member-preferences`, {
          emailTypes: uncheckedEmailTypes
        })
        .then(() => {
          this.$message.success('Your preferences have been saved.');
          this.$store.commit('loading', false);
        })
        .catch((e) => {
          this.$message.error(e.response.data.message);
          this.$store.commit('loading', false);
        });
    }
  }
};
</script>

<style  lang="scss" scoped>
  .description{
    margin:0 0 1rem 1.8rem;
  }
</style>
